import { router } from 'expo-router';
import { Plus } from 'lucide-react-native';
import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Fab } from '@/components/ui/fab';
import { useLiquidGlass } from '@/components/ui/glass';
import { ROUTES } from '@/constants/routes';
import { useCanStartSupportThread } from '@/hooks/useSupportStaffAbilities';
import { getAccessibilityProps } from '@/util/accessibilityProps';

/** The Fab's default gap above the screen's bottom edge, kept when lifting it above the tab bar. */
const FAB_EDGE_GAP = 16;

/**
 * The inbox's button for staff to message a member as Primum Support. Shown only
 * when the server grants starting a support thread, which it does for the Primum
 * Support account alone, so staff see it while acting as that account and not
 * on their own login. Where the tab bar is glass the list scrolls beneath it, so
 * the button rides above the bar rather than behind it.
 */
export function NewSupportMessageFab() {
  const canStartSupportThread = useCanStartSupportThread();

  const { bottom } = useSafeAreaInsets();

  const scrollsUnderTabBar = useLiquidGlass() && Platform.OS !== 'web';

  if (!canStartSupportThread) {
    return null;
  }

  return (
    <Fab
      placement="bottom right"
      onPress={() => router.push(ROUTES.INBOX_COMPOSE)}
      size="lg"
      style={scrollsUnderTabBar ? { bottom: bottom + FAB_EDGE_GAP } : undefined}
      {...getAccessibilityProps({ label: 'New message', role: 'button' })}>
      <Plus color="white" height={24} width={24} />
    </Fab>
  );
}
